import { render, staticRenderFns } from "./react-emails.vue?vue&type=template&id=2a9a650c&scoped=true&"
import script from "./react-emails.vue?vue&type=script&lang=js&"
export * from "./react-emails.vue?vue&type=script&lang=js&"
import style0 from "./react-emails.vue?vue&type=style&index=0&id=2a9a650c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9a650c",
  null
  
)

export default component.exports